export default "__VITE_ASSET__DycQS6Ju__"